import { IComponentOptions } from "angular";
import { MachineConfigurationGridComponentController } from "./controller";

export const vsComponentName = "machineConfigurationGrid";

export const machineConfigurationGridComponentOptions: IComponentOptions = {
  controller: MachineConfigurationGridComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    additionalColumns: "<",
    onItemCommand: "&?",
    gridSettings: "<",
    defaultQuery: "<",
    decorateCurrentAndFutureConfigurations: "<",
    gridSelectionChanged: "&?",
    initialSelectedIds: "<?",
    showSelectButtons: "<?",
  },
  transclude: {
    gridHeader: "?gridHeader",
  },
};
